// extracted by mini-css-extract-plugin
export default {"main":"ComingSoon_main__XhqBr"};